export const DATAPOINT = 'datapoint';
export const PPTR_TEMPLATE = 'pptr-template';
export const DERIVED_CONTENT = 'derived-content';
export const ENDORSEMENT_DATA = 'endorsement-data';
export const REPEATER = 'repeater';
export const HEADING = 'heading';
